// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  // Приложение Edim: регистрация владельца (слайдер промо-заведения)
  appUrl: "https://edim.app",
  // Яндекс Метрика: только prod (dev не пишет в статистику prod)
  metrikaId: 103257661,
  useEmulators: false,
  // Prod: меню и данные — один проект edim-app (сайт edim-app-menu,
  // edim.menu), веб-приложение «Edim menu» — своя статистика в Analytics.
  // Раньше меню жило в проекте menu-edim-app-78993 (menu.edim.app) —
  // теперь там переадресация на edim.menu (firebase.redirect.json)
  firebaseAnalytics: {
    apiKey: "AIzaSyAhTKqbJNJFScgnsOExki1xcY3W4bLUiRg",
    authDomain: "edim-app.firebaseapp.com",
    projectId: "edim-app",
    storageBucket: "edim-app.appspot.com",
    messagingSenderId: "141947618852",
    appId: "1:141947618852:web:227899ac3709939f3dbab1",
    measurementId: "G-7GYYT4MC0R"
  },
  firebaseDatabase: {
    apiKey: "AIzaSyAhTKqbJNJFScgnsOExki1xcY3W4bLUiRg",
    authDomain: "edim-app.firebaseapp.com",
    projectId: "edim-app",
    storageBucket: "edim-app.appspot.com",
    messagingSenderId: "141947618852",
    appId: "1:141947618852:web:227899ac3709939f3dbab1",
    measurementId: "G-7GYYT4MC0R"
  }
};